import { AccordionActionsProps as MuiAccordionActionsProps } from '@mui/material/AccordionActions'

export type AccordionActionsProps = MuiAccordionActionsProps
